import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import { setErrorHandler } from "../errorActionHandler";

export const getAssignUsersToRolesActionHandler =
  (setState, setLoader) => async () => {
    apis.admin.assignUsersToRoles
      .getAllRolesAssignUsersToROles()
      .then((response) => {
        if (response?.data) {
          setState(response.data);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUsersRoles = (userId, setState) => async () => {
  return await apis.admin.assignUsersToRoles
    .getUserRoles(userId)
    .then((response) => {
      if (response.data) {
        setState(response.data);
      }
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const postAssignUserToRolesActionHandler =
  (data) => async (dispatch) => {
    apis.admin.assignUsersToRoles
      .postAssignUserToRoles(data)
      .then((response) => {
        if (response) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Roles successfully updated")
          );
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data == "QuotaError") {
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Number of Admins creation exceeded the quota limit. Contact Tenant Admin"
            )
          );
        } else if (err.response.data == "Not Acceptable") {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "User role not Assigned")
          );
        }
      });
  };
